<script setup>
// ============================================================================
// BonBoZ: trang Thống kê > SAO LƯU — dựng theo đúng bố cục Pancake.
//
// Đây là trang DUY NHẤT trong phần Thống kê không phải để đọc số: nó tạo việc.
// Chọn loại dữ liệu + khoảng ngày + vài ô tick → "Tạo yêu cầu" → một job dựng
// file CSV rồi đính vào chính dòng yêu cầu đó.
//
// VÌ SAO KHÔNG DÙNG LẠI EXPORT CỦA CHATWOOT: `Account::ContactsExportJob` gửi
// file qua email rồi quên. Cách của Pancake hợp hơn — mỗi yêu cầu là một dòng
// thấy được trạng thái, tải lại được, và người khác trong nhà cũng thấy.
//
// TỰ LÀM MỚI khi còn yêu cầu đang chạy: job chạy ở Sidekiq nên trang không tự
// biết lúc nào xong. Dừng hẳn khi mọi dòng đã kết thúc — hỏi máy chủ mỗi ba
// giây mãi mãi cho một trang không ai nhìn là lãng phí có thể tránh.
// ============================================================================
import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SaoLuuAPI from 'dashboard/api/bonboz/saoLuu';
import { useAlert } from 'dashboard/composables';
import { ngay } from 'dashboard/helper/dinhDangNgay';
import Button from 'dashboard/components-next/button/Button.vue';
import ReportHeader from '../components/ReportHeader.vue';
import OverviewReportFilters from '../components/OverviewReportFilters.vue';

const { t } = useI18n();

const dangTai = ref(true);
const dangGui = ref(false);
const khoang = ref(null);
const yeuCau = ref([]);

const LOAI = ['tin_nhan', 'khach', 'the'];
const loai = ref('tin_nhan');
const moLoai = ref(false);

// Bốn ô tick đầu là LÁT CẮT của rổ tin nhắn; ô cuối là bộ lọc hội thoại. Mặc
// định giống Pancake: bình luận + hộp thư.
const O_TICK = ['binh_luan', 'hop_thu', 'danh_gia', 'tin_trang'];
const loc = ref({
  binh_luan: true,
  hop_thu: true,
  danh_gia: false,
  tin_trang: false,
});
const coSdt = ref(false);

// Ba ô tick đầu chỉ có nghĩa với loại "tin nhắn": xuất danh sách khách thì
// "bình luận" không phải một lát cắt nào cả.
const coOTick = computed(() => loai.value === 'tin_nhan');

let dongHo = null;
const dangChay = computed(() =>
  yeuCau.value.some(y => ['cho', 'dang_chay'].includes(y.trang_thai))
);

const tai = async () => {
  try {
    const { data } = await SaoLuuAPI.danhSach();
    yeuCau.value = data.yeu_cau || [];
  } catch {
    useAlert(t('BONBOZ.SAO_LUU.LOI_TAI'));
  } finally {
    dangTai.value = false;
  }

  // Hẹn lượt sau viết THẲNG ở đây thay vì tách một hàm riêng: hai hàm gọi lẫn
  // nhau thì không hàm nào đứng trước được, mà `const` lại không được hoisted.
  clearTimeout(dongHo);
  if (dangChay.value) dongHo = setTimeout(tai, 3000);
};

const taoYeuCau = async () => {
  if (!khoang.value) return;
  dangGui.value = true;
  try {
    await SaoLuuAPI.tao({
      loai: loai.value,
      tu: khoang.value.from,
      den: khoang.value.to,
      loc: { ...(coOTick.value ? loc.value : {}), co_sdt: coSdt.value },
    });
    await tai();
  } catch {
    useAlert(t('BONBOZ.SAO_LUU.LOI_TAO'));
  } finally {
    dangGui.value = false;
  }
};

const xoa = async id => {
  try {
    await SaoLuuAPI.xoa(id);
    yeuCau.value = yeuCau.value.filter(y => y.id !== id);
  } catch {
    useAlert(t('BONBOZ.SAO_LUU.LOI_XOA'));
  }
};

const doiBoLoc = ({ from, to }) => {
  if (from && to) khoang.value = { from, to };
};

onMounted(tai);
onBeforeUnmount(() => clearTimeout(dongHo));

const MAU_TRANG_THAI = {
  cho: 'text-n-slate-11 bg-n-alpha-1',
  dang_chay: 'text-n-blue-11 bg-n-blue-3',
  xong: 'text-n-teal-11 bg-n-teal-3',
  loi: 'text-n-ruby-11 bg-n-ruby-3',
};
</script>

<template>
  <ReportHeader
    :header-title="$t('BONBOZ.SAO_LUU.TIEU_DE')"
    :header-description="$t('BONBOZ.SAO_LUU.MO_TA')"
  />

  <div class="flex flex-col w-full gap-4 mx-auto max-w-6xl">
    <div class="flex flex-wrap items-center gap-3">
      <!-- Loại dữ liệu đứng TRƯỚC khoảng ngày, đúng như Pancake: chọn xuất cái
           gì rồi mới chọn xuất từ bao giờ. -->
      <div class="relative shrink-0">
        <Button
          variant="outline"
          color="slate"
          trailing-icon="i-lucide-chevron-down"
          :label="$t(`BONBOZ.SAO_LUU.LOAI_${loai}`)"
          @click="moLoai = !moLoai"
        />
        <div v-if="moLoai" class="fixed inset-0 z-10" @click="moLoai = false" />
        <div
          v-if="moLoai"
          class="absolute left-0 z-20 flex flex-col gap-1 p-2 mt-1 border shadow-lg w-56 rounded-xl border-n-weak bg-n-solid-1"
        >
          <button
            v-for="x in LOAI"
            :key="x"
            type="button"
            class="px-2 py-1.5 text-sm text-left rounded text-n-slate-12 hover:bg-n-alpha-1"
            @click="
              loai = x;
              moLoai = false;
            "
          >
            {{ $t(`BONBOZ.SAO_LUU.LOAI_${x}`) }}
          </button>
        </div>
      </div>

      <OverviewReportFilters
        class="flex-1 min-w-72"
        @filter-change="doiBoLoc"
      />
    </div>

    <section class="border rounded-xl border-n-weak bg-n-solid-2">
      <div class="px-4 pt-3 -mb-px">
        <span
          class="inline-block pb-2 text-sm font-medium border-b-2 border-n-brand text-n-brand"
        >
          {{ $t('BONBOZ.XUAT.NUT') }}
        </span>
      </div>

      <div
        class="flex flex-wrap items-start justify-between gap-3 p-4 border-t border-n-weak"
      >
        <div class="flex flex-col gap-2">
          <div v-if="coOTick" class="flex flex-wrap gap-4">
            <label
              v-for="o in O_TICK"
              :key="o"
              class="flex items-center gap-2 text-sm cursor-pointer text-n-slate-12"
            >
              <input v-model="loc[o]" type="checkbox" class="accent-n-brand" />
              {{ $t(`BONBOZ.SAO_LUU.O_${o}`) }}
            </label>
          </div>
          <label
            class="flex items-center gap-2 text-sm cursor-pointer text-n-slate-12"
          >
            <span
              class="block i-lucide-filter size-4 text-n-slate-10"
              aria-hidden="true"
            />
            <input v-model="coSdt" type="checkbox" class="accent-n-brand" />
            {{ $t('BONBOZ.SAO_LUU.O_co_sdt') }}
          </label>
        </div>

        <Button
          color="blue"
          :label="$t('BONBOZ.SAO_LUU.TAO')"
          :is-loading="dangGui"
          :disabled="!khoang || dangGui"
          @click="taoYeuCau"
        />
      </div>

      <div
        v-if="dangTai"
        class="m-4 rounded-lg h-40 bg-n-alpha-2 animate-pulse"
      />

      <!-- Danh sách yêu cầu. Rỗng thì có hình hộp và chữ "Trống", đúng như
           Pancake — khung trắng trơn không nói được là chưa có hay là hỏng. -->
      <div v-else-if="!yeuCau.length" class="py-20 m-4 rounded-lg bg-n-alpha-1">
        <span class="flex flex-col items-center gap-2 text-n-slate-10">
          <span class="block i-lucide-inbox size-10" aria-hidden="true" />
          <span class="text-sm">{{ $t('BONBOZ.TONG_DAI.TRONG') }}</span>
        </span>
      </div>

      <div v-else class="overflow-auto border-t max-h-96 border-n-weak">
        <!-- BonBoZ: boc de cuon ngang. Bang nhieu cot hon be ngang man thi bi CAT
             cung chu khong cuon — tren dien thoai mat han cac cot ben phai. Hai man
             Cam xuc va Quang cao da boc dung tu truoc, day la lam not cho deu. -->
        <div class="overflow-x-auto">
          <table class="w-full text-sm border-collapse">
            <thead class="sticky top-0 z-10 bg-n-slate-2">
              <tr class="text-xs border-b border-n-weak text-n-slate-11">
                <th class="px-3 py-2.5 font-medium text-start">
                  {{ $t('BONBOZ.SAO_LUU.COT_LOAI') }}
                </th>
                <th
                  class="px-3 py-2.5 font-medium text-start whitespace-nowrap"
                >
                  {{ $t('BONBOZ.SAO_LUU.COT_KHOANG') }}
                </th>
                <th class="px-3 py-2.5 font-medium text-start">
                  {{ $t('BONBOZ.SAO_LUU.COT_NGUOI') }}
                </th>
                <th class="px-3 py-2.5 font-medium text-start">
                  {{ $t('BONBOZ.SAO_LUU.COT_TRANG_THAI') }}
                </th>
                <th class="px-3 py-2.5 font-medium text-end">
                  {{ $t('BONBOZ.SAO_LUU.COT_SO_DONG') }}
                </th>
                <th class="px-3 py-2.5 font-medium text-end">
                  {{ $t('BONBOZ.SAO_LUU.COT_TEP') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="y in yeuCau"
                :key="y.id"
                class="border-b border-n-weak last:border-b-0 hover:bg-n-alpha-1"
              >
                <td class="px-3 py-2 text-n-slate-12">
                  {{ $t(`BONBOZ.SAO_LUU.LOAI_${y.loai}`) }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap text-n-slate-11">
                  {{ ngay(y.tu * 1000, 'ngayDay') }} –
                  {{ ngay(y.den * 1000, 'ngayDay') }}
                </td>
                <td class="px-3 py-2 truncate text-n-slate-11">
                  {{ y.nguoi || '—' }}
                </td>
                <td class="px-3 py-2">
                  <span
                    v-tooltip.top="y.loi || null"
                    class="px-2 py-0.5 text-xs rounded-full whitespace-nowrap"
                    :class="MAU_TRANG_THAI[y.trang_thai]"
                  >
                    {{ $t(`BONBOZ.SAO_LUU.TT_${y.trang_thai}`) }}
                  </span>
                </td>
                <td class="px-3 py-2 tabular-nums text-end text-n-slate-12">
                  {{ y.so_dong ?? '—' }}
                </td>
                <td class="px-3 py-2 text-end">
                  <span class="inline-flex items-center gap-1">
                    <a
                      v-if="y.tep"
                      :href="y.tep"
                      download
                      class="text-sm rounded text-n-brand hover:underline"
                    >
                      {{ $t('BONBOZ.SAO_LUU.TAI') }}
                    </a>
                    <Button
                      variant="ghost"
                      color="slate"
                      size="sm"
                      icon="i-lucide-trash-2"
                      :aria-label="$t('BONBOZ.SAO_LUU.XOA')"
                      @click="xoa(y.id)"
                    />
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>
